import { Box, Button, Typography, makeStyles } from '@material-ui/core';
import LockIcon from '@material-ui/icons/Lock';
import { Content, Header, Page } from '@backstage/core-components';
import { useNavigate } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  wrap: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    minHeight: '46vh',
    gap: theme.spacing(1),
  },
  icon: { fontSize: 44, color: theme.palette.textSubtle },
  detail: { maxWidth: '46ch', color: theme.palette.textSubtle },
}));

/**
 * Shown instead of a feature the person has not been granted.
 *
 * Deliberately says which permission is missing. The alternative — a blank
 * "not found" — turns a two-minute request to an administrator into a
 * support ticket about a broken page.
 */
export const NoAccessPage = (props: { permissionName?: string }) => {
  const classes = useStyles();
  const navigate = useNavigate();

  return (
    <Page themeId="tool">
      <Header title="No access" />
      <Content>
        <Box className={classes.wrap}>
          <LockIcon className={classes.icon} />
          <Typography variant="h6">You do not have access to this</Typography>
          <Typography variant="body2" className={classes.detail}>
            Ask an administrator to grant it
            {props.permissionName ? (
              <>
                {' '}
                — the permission is <code>{props.permissionName}</code>
              </>
            ) : null}
            .
          </Typography>
          <Box mt={2}>
            <Button variant="outlined" onClick={() => navigate('/')}>
              Back to the console
            </Button>
          </Box>
        </Box>
      </Content>
    </Page>
  );
};
